import React, { FC, useContext, useMemo, useState } from 'react';

import { Descendant } from 'slate';

// components
import FormulaEditorToolbarIcon from '../../../../../views/formulaCreate/formulaEditor/assistant/components/FormulaEditorToolbarIcon';

//constants
import ICONS from '../../../../../constants/icons';

// contexts
import { EditorContext } from '../../../../../context/EditorContext';

//helpers
import { showImageAlternates } from '../../../../../helpers/formulaHelpers';

//models
import {
    ElementKind,
    ImageVariantElement,
} from '../../../../../models/editor.model';

import ImageAlternateContainer from './ImageAlternateContainer';

interface ImageMainProps {
    handleUpdateStructure: (newValue: Descendant[]) => void;
    isEditable: boolean;
}

const ImageMain: FC<ImageMainProps> = ({
    handleUpdateStructure,
    isEditable,
}) => {
    const [showImageAlternateIconModal, setShowImageAlternateIconModal] =
        useState<boolean>(false);

    const {
        editorDetails: { formula, formulaType },
    } = useContext(EditorContext);

    const element = useMemo<ImageVariantElement>(
        () =>
            formula?.structure?.find(
                (i: any) => i?.kind === ElementKind.image,
            ) as ImageVariantElement,
        [formula?.structure],
    );

    const hasDataset = useMemo<boolean>(
        () => element?.datasetField !== undefined,
        [element],
    );

    const isDisabled = useMemo<boolean>(() => {
        if (hasDataset) return true;
        if (!formula?.id) return true;
        return !showImageAlternates(formulaType!, element || {});
    }, [formula, element, formulaType, hasDataset]);

    const title = useMemo<string>(() => {
        if (hasDataset) return 'Remove dataset to add image alternates';
        return 'Add image alternates';
    }, [hasDataset]);

    return (
        <>
            <FormulaEditorToolbarIcon
                isDisabled={isDisabled}
                Icon={ICONS.imageAlternate}
                title={title}
                onIconClick={() => setShowImageAlternateIconModal(true)}
            />
            {showImageAlternateIconModal && (
                <ImageAlternateContainer
                    handleUpdateStructure={handleUpdateStructure}
                    setShowImageAlternateIconModal={
                        setShowImageAlternateIconModal
                    }
                    showImageAlternateIconModal={showImageAlternateIconModal}
                    isEditable={isEditable}
                />
            )}
        </>
    );
};

export default ImageMain;
